var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from "./AuthenticationContext";
import queryString from 'query-string';
import { AuthenticationDriverMevodoAccounts } from "./AuthenticationDriverMevodoAccounts";
import { AssetImage, useComponentDidMount } from "@mevodo/mv-react-helpers";
import { AuthenticationWaitingPage } from "./AuthenticationWaitingPage";
export default function AuthenticationAutomaticSignInProcessor(props) {
    var context = useAuth();
    var authDriver = new AuthenticationDriverMevodoAccounts();
    useComponentDidMount(function () {
        var _a;
        // parsed query          
        var query = queryString.parse(window.location.search);
        // check if we have a token in the uri 
        if (query['access_token']) {
            // extract the token 
            var token = query['access_token'];
            // establish the session 
            context.establishSession && context.establishSession(token);
            // ensure the session is valid 
            context.verifySession();
            // redirect to final target            
            var finalTarget = sessionStorage.getItem('mv.final.target');
            if (finalTarget) {
                sessionStorage.removeItem('mv.final.target');
                window.location.replace(finalTarget);
            }
        }
        else if (query['logout_requested']) {
            authDriver.triggerLogoutFlow(props.authentication_endpoint);
        }
        else if (!context.authenticated) {
            authDriver.triggerAuthenticationFlow(props.client_id, props.scope, props.authentication_endpoint);
        }
        else if (context.authenticated) {
            // verify the current session 
            if (!context.verifySession()) {
                authDriver.triggerAuthenticationFlow(props.client_id, props.scope, props.authentication_endpoint);
            }
            // calculate the next interval
            var secondsUntilTokenExpires = 30;
            if (context.currentTokenExpiration) {
                secondsUntilTokenExpires = (((_a = context.currentTokenExpiration) === null || _a === void 0 ? void 0 : _a.getTime()) - (new Date()).getTime()) / 1000;
            }
            // configure the verify session
            setInterval(function () {
                if (!context.verifySession()) {
                    authDriver.triggerAuthenticationFlow(props.client_id, props.scope, props.authentication_endpoint);
                }
            }, secondsUntilTokenExpires);
        }
    });
    if (context.authenticated) {
        return (_jsx(_Fragment, { children: props.children }));
    }
    else {
        return (_jsxs(AuthenticationWaitingPage, { children: [props.waiting_page_image ?
                    (_jsx("p", { children: _jsx(AssetImage, { src: props.waiting_page_image, alt: "sign in logo", width: "250" }) })) :
                    (_jsx(_Fragment, {})), _jsx("h2", __assign({ style: { textAlign: 'center' } }, { children: "Signing in...." }))] }));
    }
}
